import { useCallback, useEffect, useState } from 'react';
import { apiClient } from '../../../services/apiClient';
import { DeviceDetailCore } from '../useDeviceDetail';

/**
 * The V2/Conf panel: what the device itself receives from /v2/conf,
 * fetched the first time the panel is shown and on demand afterwards.
 */
export const useDevicesDetailsConf = (core: DeviceDetailCore, active: boolean) => {
  const { device, isOpen } = core;
  const [data, setData] = useState<Record<string, unknown> | null>(null);
  const [loading, setLoading] = useState(false);
  const [strict, setStrict] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    setData(null);
    setLoading(false);
    setStrict(false);
  }, [isOpen, device?.idDevice]);

  // Fetch when shown, or after a refresh / strict toggle cleared the payload.
  useEffect(() => {
    if (!active || !device?.idDevice) return;
    if (data !== null || loading) return;
    setLoading(true);
    const url = strict ? `/v2/conf/${device.idDevice}?strict=true` : `/v2/conf/${device.idDevice}`;
    apiClient.get(url)
      .then((payload) => setData(payload as Record<string, unknown>))
      .catch((err) => {
        console.error('Failed to load v2/conf data:', err);
        setData(null);
      })
      .finally(() => setLoading(false));
  }, [active, device?.idDevice, data, loading, strict]);

  const refresh = useCallback(() => setData(null), []);
  const toggleStrict = useCallback(() => {
    setStrict((prev) => !prev);
    setData(null);
  }, []);

  return { data, loading, strict, toggleStrict, refresh };
};
